import React from "react";
import * as appAction from "../actions/appactions";
import { useDispatch, useSelector } from "react-redux";

// export default function LoadingIndicator(props) {
//   const state = useSelector((state) => state.appReducer);

//   if (state.loadingIndicatorCounter > 0) {
//     return (
//       <div className="loading-progress-container">
//         <div className="loading-progress-overlay"></div>
//         <div className="loading-progress-message-container">
//         <div class="spinner-border avatar-md text-primary" role="status"></div> <p> Loading...</p>
//         </div>
//       </div>
//     );
//   }
// }

const LoadingIndicator = ({ message = "Loading, please wait..." }) => {
  const state = useSelector((state) => state.appReducer);
  if (state.loadingIndicatorCounter > 0) {
    return (
      <div className="overlay">
        <div className="loader-container">
          <div className="heartbeat-loader"></div>
          <p className="loader-text">Loading ...</p>
        </div>
      </div>
      // <div className="loading-overlay">
      //   <div className="spinner">
      //     <div className="shield-icon">
      //       <svg
      //         xmlns="http://www.w3.org/2000/svg"
      //         viewBox="0 0 24 24"
      //         fill="#015fc9"
      //         width="50"
      //         height="50"
      //       >
      //         <path d="M12 0L2 4v6c0 5.52 3.37 10.74 10 14 6.63-3.26 10-8.48 10-14V4L12 0z" />
      //       </svg>
      //     </div>
      //     <div className="circle"></div>
      //   </div>
      //   <p className="loading-message">{message}</p>
      // </div>
      // <>
      //   <div class="pencil">
      //     <div class="pencil__ball-point"></div>
      //     <div class="pencil__cap"></div>
      //     <div class="pencil__cap-base"></div>
      //     <div class="pencil__middle"></div>
      //     <div class="pencil__eraser"></div>
      //   </div>
      //   {/* <div class="line"></div> */}
      //   <h2>Page Loading...Please Wait</h2></>
    );
  }
};

export default LoadingIndicator;